import React, {Component} from 'react'

export default class NoAccess extends Component {
    render() {
        return (
            <div className='d-flex flex-row'>You do not have access to this area</div>
        );
    }
}
